/**
 * @flow
 * @relayHash afc56ed2011da341154fc616dc2d628f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type POApprovalRulesQueryVariables = {||};
export type POApprovalRulesQueryResponse = {|
  +poApprovalRules: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +minAmount: ?number,
        +maxAmount: ?number,
        +approver: {|
          +id: string,
          +firstName: string,
          +lastName: string,
          +email: any,
        |},
        +createdAt: any,
      |}
    |}>
  |}
|};
export type POApprovalRulesQuery = {|
  variables: POApprovalRulesQueryVariables,
  response: POApprovalRulesQueryResponse,
|};
*/


/*
query POApprovalRulesQuery {
  poApprovalRules {
    edges {
      node {
        id
        minAmount
        maxAmount
        approver {
          id
          firstName
          lastName
          email
        }
        createdAt
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "POApprovalRuleEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "POApprovalRule",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "minAmount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "maxAmount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "approver",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "endCursor",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasNextPage",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "POApprovalRulesQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "poApprovalRules",
        "name": "__POApprovalRules_poApprovalRules_connection",
        "storageKey": null,
        "args": null,
        "concreteType": "POApprovalRuleConnection",
        "plural": false,
        "selections": (v1/*: any*/)
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "POApprovalRulesQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "poApprovalRules",
        "storageKey": null,
        "args": null,
        "concreteType": "POApprovalRuleConnection",
        "plural": false,
        "selections": (v1/*: any*/)
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "poApprovalRules",
        "args": null,
        "handle": "connection",
        "key": "POApprovalRules_poApprovalRules",
        "filters": []
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "POApprovalRulesQuery",
    "id": null,
    "text": "query POApprovalRulesQuery {\n  poApprovalRules {\n    edges {\n      node {\n        id\n        minAmount\n        maxAmount\n        approver {\n          id\n          firstName\n          lastName\n          email\n        }\n        createdAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "poApprovalRules"
          ]
        }
      ]
    }
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1d1235170e057903d48157d7e38d79fa';
module.exports = node;
